<template>
  <v-row>
    <v-col cols="12" class="text-h6 pt-5 pb-0">
      {{ `Protocolo: ${value.protocolo}` }}
    </v-col>

    <v-col cols="12" class="text-caption pt-0 mb-2">
      {{
        `Data da Inscrição: ${format(
          parseISO(value.data_cadastro),
          "dd/MM/yyyy",
        )}`
      }}
    </v-col>

    <v-col cols="12" md="6" class="py-0 ">
      <CInput
        v-model="value.posicao"
        :disabled="!value.editing"
        :clearable="false"
        label="Posição"
      />
    </v-col>

    <v-col cols="12" md="6" class="py-0">
      <CInput v-model="value.status" label="Status" disabled />
    </v-col>

    <v-col cols="12" md="6" class="py-0">
      <CInput :value="tipoLabel" label="Tipo" disabled />
    </v-col>

    <v-col v-if="value.tipo === 'TRANSFERENCIA'" cols="12" md="6" class="py-0">
      <CInput v-model="value.unidade_transferencia" label="Unidade Desejada" disabled />
    </v-col>

    <v-col
      v-if="value.status === 'DEFERIDO' && turmaDeferida"
      cols="12"
      class="py-0 mb-2"
    >
      <v-alert type="success" dense outlined class="mb-0">
        <span class="text-subtitle-2 font-weight-bold">
          Turma Deferida: {{ turmaDeferida.nomeCompleto }}
          <span v-if="turmaDeferida.unidadeEnsino">
            - {{ turmaDeferida.unidadeEnsino.nomeCompleto }}
          </span>
        </span>
      </v-alert>
    </v-col>

    <template
      v-if="
        value.status === 'DEFERIDO' && value.turma_deferida && !turmaDeferida
      "
    >
      <v-col cols="12" class="pb-0 pt-2">
        <v-skeleton-loader type="list-item-three-line" />
      </v-col>
    </template>
  </v-row>
</template>

<script>
import CInput from "@/components/Input";
import { format, parseISO } from "date-fns";

export default {
  name: "PrimeiraSecao",

  components: {
    CInput,
  },

  props: {
    value: {
      type: Object,
      required: true,
    },
    turmaDeferida: {
      type: Object,
      default: () => null,
    },
  },

  computed: {
    tipoLabel() {
      return this.value.tipo === "TRANSFERENCIA" ? "Transferência" : "Cadastro";
    },
  },

  methods: {
    format,
    parseISO,
  },
};
</script>
